import Field from "@/components/form/Field.tsx";
import {Label} from "@/components/ui/label.tsx";
import {cn} from "@/lib/utils.ts";
import {Textarea} from "@/components/ui/textarea.tsx";
import {ChangeEvent} from "react";

export default function NyugdijLongTextField(props: TextFieldProps) {
    const className = cn("w-full", props.className, props.disabled ? "text-gray-400" : "");
    return <Field defaultValue={props.defaultValue} name={props.name} validate={props.validate}>
        {(field) => {
            return (
                <>
                    <Label className={className}>{props.label}
                        <Textarea className={className} rows={7} value={field.value}
                               onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                                   //@ts-ignore
                                   if (e.nativeEvent.inputType != "deleteContentBackward") {
                                       const lines = e.target.value.split("\n");
                                       const l = lines.map(x => {
                                           if (x.at(0) != '-') {
                                               return "- " + x;
                                           } else {
                                               return x;
                                           }
                                       });
                                       e.target.value = l.join("\n")
                                   }
                                   field.onChange(e.target.value)

                               }}
                               onBlur={field.onBlur}/>
                        <div className={"h-4"}>
                            <span className={"text-destructive text-sm"}>{field.error}</span>
                        </div>
                    </Label>
                </>)
        }}
    </Field>
}